import { colorForPerson, firstName } from "../lib/personColor";

export interface NameDotProps {
  /** Stable person id; drives the per-person color. */
  id: string;
  /** Display name, when this view knows it. Empty/absent renders a neutral
   * person glyph instead of a guessed letter or a bare "?". */
  name?: string | null;
}

/**
 * The small round initial used for an assignee or helper (base styling in
 * `styles.css`'s `.name-dot`). Decorative: the surrounding control carries
 * the accessible name, so this is always `aria-hidden`.
 */
export function NameDot({ id, name }: NameDotProps) {
  const initial = (firstName(name ?? "") || name || "").trim().charAt(0);
  if (!initial) {
    return (
      <span class="name-dot is-unknown" aria-hidden="true">
        <svg viewBox="0 0 16 16" width="16" height="16" focusable="false">
          <circle cx="8" cy="5.5" r="3" fill="currentColor" />
          <path d="M2.5 14.5c0-3 2.5-5 5.5-5s5.5 2 5.5 5z" fill="currentColor" />
        </svg>
      </span>
    );
  }
  return (
    <span class="name-dot" aria-hidden="true" style={{ background: colorForPerson(id) }}>
      {initial.toUpperCase()}
    </span>
  );
}
